export default __webpack_public_path__ + "static/media/circuit-board-gear.c4bff104.png";